<template>
  <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="dialogVisible">
    <el-form ref="form" label-position="top" :inline="false" label-width="150px" :model="form" :rules="rules">
      <el-row>
        <el-col :span="24">
          <el-form-item :label="$t('OrdinaryOrderMix.EditReceiverInfo.name')" prop="receiverName">
            <BjInput
              v-model="form.receiverName"
              :maxlength="MAX_LENGTH.DEFAULT"
              :placeholder="$t('inputText')"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <BjFormItemMobile
            v-model="form.mobile"
            :label="$t('OrdinaryOrderMix.EditReceiverInfo.phone')"
            prop="mobile"
            :required="true"
          />
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$t('OrdinaryOrderMix.EditReceiverInfo.address')" prop="fullAddress">
            <el-col :span="11">
              <BjRegionCascader
                v-model="regionList"
                class="full-width"
                is-array
                clearable
                @change="onChangeRegionCascader"
              />
            </el-col>
            <el-col :span="13">
              <BjInput
                v-model="form.address"
                :maxlength="MAX_LENGTH.DEFAULT"
                :placeholder="$t('OrdinaryOrderMix.EditReceiverInfo.Detailed')"
                clearable
              />
            </el-col>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('cancelText') }}</el-button>
      <el-button type="primary" @click="confirmEditRemarks">{{ $t('okText') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>
import BjRegionCascader from '@/components/BjRegionCascader';
export default {
  name: 'BusinessOrderInternalViewFormEditReceiverInfo',
  components: { BjRegionCascader },
  props: {
    id: {
      type: String,
      default: null,
    },
    info: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      title: this.$t('OrdinaryOrderMix.EditReceiverInfo.receipt'),

      regionList: [],

      // 弹窗显示
      dialogVisible: false,

      form: {
        receiverName: null,
        mobile: null,
        phone: null,

        province: null,
        provinceCode: null,

        city: null,
        cityCode: null,

        district: null,
        districtCode: null,

        address: null,

        town: null,
      },
    };
  },
  computed: {
    // 表单校验
    rules() {
      const validateFullAddress = (rule, value, callback) => {
        this.$nextTick(() => {
          if (!this.form.provinceCode || !this.form.cityCode || !this.form.districtCode) {
            callback(new Error(this.$t('OrdinaryOrderMix.EditReceiverInfo.select')));
          }
          if (!this.form.address) {
            callback(new Error(this.$t('OrdinaryOrderMix.EditReceiverInfo.enter')));
          }
          callback();
        });
      };
      return {
        receiverName: [{ required: true, message: this.$t('OrdinaryOrderMix.EditReceiverInfo.the'), trigger: 'blur' }],
        mobile: [{ required: true, message: this.$t('OrdinaryOrderMix.EditReceiverInfo.mobile'), trigger: 'blur' }],

        fullAddress: { required: true, validator: validateFullAddress, trigger: 'change' },
      };
    },
  },
  methods: {
    onChangeRegionCascader(v) {
      this.form.province = v[0].label;
      this.form.city = v[1].label;
      this.form.district = v[2].label;

      this.form.provinceCode = v[0].value;
      this.form.cityCode = v[1].value;
      this.form.districtCode = v[2].value;
    },

    // 修改
    onEdit() {
      this.form = Object.assign({}, this.info);
      if (!this.form.mobile) this.form.mobile = this.form.phone;

      this.regionList = [
        Number(this.form.provinceCode),
        Number(this.form.cityCode),
        Number(this.form.districtCode),
      ];

      this.dialogVisible = true;
    },
    confirmEditRemarks() {
      this.form.phone = this.form.mobile;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('editBaseInfoApi', { orderId: this.id, receiverInfoDTO: this.form });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
